var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"relative header-space container",attrs:{"fluid":""}},[_c('div',[_c('h1',[_vm._v("Mapping Editor")]),_c('v-card',{staticClass:"pt-4 pb-3 px-4"},[_c('p',[_vm._v("An dieser Stelle folgt ein Mapping Edior.")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }